import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { ChipItemWrapper } from "@similarweb/ui-components";

export const StyledChipItemWrapper = styled(ChipItemWrapper)`
    padding: 0;
    color: ${colorsPalettes.carbon["0"]};
    background-color: ${rgba(colorsPalettes.carbon["500"], 0.8)};

    span {
        color: ${colorsPalettes.carbon["0"]};
    }

    & > span {
        margin-right: 0;
        padding-right: 4px;
    }

    &:hover {
        background-color: ${colorsPalettes.carbon["500"]};
        .SWReactIcons {
            svg path {
                fill: ${colorsPalettes.carbon["0"]};
            }
        }
    }

    .SWReactIcons {
        svg path {
            fill: ${colorsPalettes.carbon["0"]};
        }
    }
`;
